import Tooltip from './Tooltip';
import type {
  IProps as ITooltipProps,
  ITooltipRef,
  TooltipPlacement,
  TooltipContent,
  LazyTooltipContent,
  ITooltipListItem,
  ITooltipTableRow,
  ITooltipListContent,
  ITooltipListGroup,
  ITooltipGroupedListContent,
  ITooltipTableContent,
  TooltipListType,
} from './Tooltip';

export type {
  ITooltipRef,
  ITooltipProps,
  TooltipPlacement,
  TooltipContent,
  LazyTooltipContent,
  ITooltipListItem,
  ITooltipTableRow,
  ITooltipListContent,
  ITooltipListGroup,
  ITooltipGroupedListContent,
  ITooltipTableContent,
  TooltipListType,
};
export default Tooltip;
